import { Injectable } from '@angular/core';
import { QueueingSubject } from 'queueing-subject';
import { Observable } from 'rxjs/Observable';
import websocketConnect, { Connection } from 'rxjs-websockets'
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

// import { Message } from '../models';

// this.date = new Date().toISOString();
// //this.serveraddr = 'ws://mechow.duckdns.org:23077/{"e":"mitchell@intelligentconcepts.com", "p":"qwerty", "t":"';
// this.serveraddr = 'ws://192.168.1.6:23077/{"e":"mitchell@intelligentconcepts.com", "p":"qwerty", "t":"';
// this.key = '","k":"f2mVZeO8xrC1nQjhEkT4gdOcQsXy4OK7wP2MFreSgYg="}';
// const STATUS_URL = this.serveraddr + this.date + this.key;

// this subject queues as necessary to ensure every message is delivered
// const input = new QueueingSubject()

// this method returns an object which contains two observables
//const { messages, connectionStatus } = websocketConnect(STATUS_URL, input)


@Injectable()
export class ServerSocket {
  private messageID: number = 1;

  private inputStream: QueueingSubject<any>

  public messages: Observable<any>;
  public connectionStatus: Observable<number>;
  //private _messages: BehaviorSubject<Message[]>;
  // private dataStore: {
  //   messages: Message[]
  // }

  public connect(STATUS_URL) {
    // if (this.messages)
    //   return

    let con: Connection = websocketConnect(
      STATUS_URL,
      this.inputStream = new QueueingSubject<any>()
    );

    this.messages = con.messages.share().retryWhen(errors => errors.delay(1000));
    this.connectionStatus = con.connectionStatus;

    // Using share() causes a single websocket to be created when the first
    // observer subscribes. This socket is shared with subsequent observers
    // and closed when the observer count falls to zero.
    // this.messages = websocketConnect(
    //   STATUS_URL,
    //   this.inputStream = new QueueingSubject<any>()
    // ).messages.share().retryWhen(errors => errors.delay(1000))



    // this.messages.retryWhen(errors => errors.delay(1000)).subscribe(message => {
    //   console.log(message)
    // })

    //this.connectionStatus = this.messages.share();
    // this.connectionStatus = websocketConnect(
    //   STATUS_URL,
    //   this.inputStream = new QueueingSubject<any>()
    // ).connectionStatus.share()

    // this.connectionStatus = websocketConnect(
    //   STATUS_URL,
    //   this.inputStream = new QueueingSubject<any>()
    // ).connectionStatus.share()
    // const connectionStatusSubscription = connectionStatus.subscribe(numberConnected => {
    //   console.log('number of connected websockets:', numberConnected)
    // })

  };

  public send(message: any, msgCallbacks?: any): void {
    // If the websocket is not connected then the QueueingSubject will ensure
    // that messages are queued and delivered when the websocket reconnects.
    // A regular Subject can be used to discard messages sent when the websocket
    // is disconnected.
    let date = new Date().toISOString();
    this.messageID = this.messageID + 1;

    message["timestamp"] = date;
    message["msg_id"] = this.messageID;

    // Wrap message in cmd_msg property inside of an object to match expected JSON payload.
    message = {
      cmd_msg: message
    };
    console.log(message)
    this.inputStream.next(JSON.stringify(message));
    var msgSubscription = this.messages.subscribe(msg => {
      // On next
      if (msgCallbacks.nextHandler) {
        msgCallbacks.nextHandler(msg, msgSubscription);
      }
    },
      error => {
        // On error
        if (msgCallbacks.errorHandler) {
          msgCallbacks.errorHandler(error);
        }

        msgSubscription.unsubscribe();
      },
      () => {
        // On complete
        if (msgCallbacks.completeHandler) {
          msgCallbacks.completeHandler();
        }

        msgSubscription.unsubscribe();
      });
  };

}



// WEBPACK FOOTER //
// ./src/providers/server-socket.ts